import moment, { Moment } from 'moment-timezone';

export const saoPauloTZ = 'America/Sao_Paulo';

export function formatDate(date: Date | Moment | undefined, format = 'DD/MM/YYYY'): string {
  if (date == undefined) return '';
  return moment(date).format(format);
}

export function convertTZ(date: Moment, timeZone: string = saoPauloTZ) {
  return date.tz(timeZone);
}

export function isValid(date?: Moment) {
  if (!date) return false;
  let momentDate = moment(date);
  return !!momentDate?.isValid() && momentDate.isBetween(moment('1900-01-01'), moment('2100-01-01'));
}
